export default "__VITE_ASSET__ZGhCg0LX__"